import { useEffect, useRef, useState } from "react";
import { paymentStatus } from "../helpers";

export const PAYMENT_POLLING_INTERVAL_MS = 5000;
export const PAYMENT_POLLING_TIMEOUT_MS = 2 * 60 * 1000;

/**
 * Consulta el pago cada `PAYMENT_POLLING_INTERVAL_MS` mientras siga
 * `PENDING`, hasta `PAYMENT_POLLING_TIMEOUT_MS` desde que se vio pendiente
 * @param {string} [status] Estado actual del pago
 * @param {function} poll Pide el pago al back
 * @returns {{ isTimedOut: boolean }}
 */
const usePaymentPolling = (status, poll) => {
  const [isTimedOut, setIsTimedOut] = useState(false);
  const startedAt = useRef(null);
  const pollRef = useRef(poll);
  pollRef.current = poll;

  useEffect(() => {
    if (status !== paymentStatus.PENDING || isTimedOut) {
      return;
    }
    if (startedAt.current === null) {
      startedAt.current = Date.now();
    }
    const remaining =
      PAYMENT_POLLING_TIMEOUT_MS - (Date.now() - startedAt.current);
    const interval = setInterval(
      () => pollRef.current(),
      PAYMENT_POLLING_INTERVAL_MS
    );
    const timeout = setTimeout(() => setIsTimedOut(true), remaining);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [status, isTimedOut]);

  return { isTimedOut };
};

export default usePaymentPolling;
